// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"4487b168","584":"d54e5c97","768":"957a68e2","787":"84aef60c","886":"a90f3027"}[chunkId] + ".chunk.js";
};